import {FunctionComponent} from 'react';
import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';
import styles from './styles.module.scss';

interface SpinnerProps {
  className?: string;
  inverted?: boolean;
  thin?: boolean;
}

const Spinner: FunctionComponent<SpinnerProps> = ({className, inverted, thin}) => {
  const classes = clsx(styles.loader, inverted && styles.inverted, thin && styles.thin, twMerge('size-12', className));

  return <div role="status" className={classes} />;
};

export default Spinner;
